import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BASE_URL, MEDIA_URL} from '../../shared/constants';
import {IArticle} from './IArticle';
import {Observable, of} from 'rxjs';
import {INotaryInfo} from './INotaryInfo';
import {Router, ActivatedRoute} from '@angular/router';
import {Offer} from 'src/app/models/Offer';
import {News} from '../../models/News';
import {catchError, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BaseHttpService {
  selectedFilteredPageIndex: number;
  mainSlidersOffers: Offer[];
  mainSliderOfferRequestSent: boolean;
  loadNews: Observable<News[]>;

  constructor(private http: HttpClient, public router: Router, private route: ActivatedRoute) {
    this.http
      .get<INotaryInfo>(BASE_URL + '/calc/calc/')
      .subscribe((data: INotaryInfo) => {
        this.entryTax = data.entry_tax;
        this.localTax = data.local_tax;
      });

    this.selectedFilteredPageIndex = 1;
    this.mainSlidersOffers = [];
    this.mainSliderOfferRequestSent = false;
  }

  ARTICLE_URL = '/article/article/';
  NEWS_URL = '/news/news';
  CALCULATOR_NUMBERS_URL = '/calc/calc';
  LIKE_COUNTER_URL = '/property/like/';
  OFFER_SUBSCRIPTION_URL = '/subs/addsub/';
  OFFER_CREATION_URL = '/property/offer/';
  REQUEST_URL = '/contact/contact/';

  SLIDERS_OFFERS_URL = '/property/slider/';
  USERS_INFO_URL = '/user/userinfo';
  REGION_URI = '/region/region/';

  entryTax: number;
  localTax: number;

  getArticle(paramValue: string): Observable<any> {
    return this.http.get<IArticle>(BASE_URL + this.ARTICLE_URL, {
      params: {key: paramValue}
    });
  }

  getMainPageSlidersOffers(): Observable<any> {
    return this.http.get(BASE_URL + this.SLIDERS_OFFERS_URL);
  }

  getNews(): Observable<News[]> {
    if (!this.loadNews) {
      this.loadNews = this.http.get<News[]>(BASE_URL + this.NEWS_URL);
    }
    return this.loadNews;
  }

  getUsers() {
    return this.http.get<any[]>(BASE_URL + this.USERS_INFO_URL);
  }

  postNewOfferLike(currentOfferId: number): Observable<any> {
    const body = {};
    (body as any).property_id = currentOfferId;
    return this.http.post(BASE_URL + this.LIKE_COUNTER_URL, body);
  }

  getRegions(): Observable<any[]> {
    return this.http.get<any[]>(BASE_URL + this.REGION_URI).pipe(
      tap(),
    );
  }

  postNewRequest(header1: string, name: string, email: string, phone: string, question: string, successCallback: () => void): void {
    const body = {header: header1, name: name || '', e_mail: email, phone: phone || '', message: question};
    this.http.post(BASE_URL + this.REQUEST_URL, body)
      .subscribe((data) => {
          successCallback();
        },
        err => {
          if (err.status === 406) {
            console.log('Enter a valid Email please!');
          } else {
            console.log('404_NOT_FOUND');
          }
        }
      );
  }
}
